// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_j6-1";
export var quotedThread = "_j6-0";